// One-tap "+" add-to-cart on the product cards: adds 1 unit via /cart/add.js
// and opens the cart drawer with the fresh contents (Dawn's own
// renderContents re-renders the drawer + header bubble, rebinds listeners,
// and opens it; the floating cart FAB mirrors the bubble automatically).
(function () {
  var busy = false;

  var sectionIds = function () {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return drawer.getSectionsToRender().map(function (s) {
        return s.id;
      });
    }
    return ['cart-icon-bubble'];
  };

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-quick-add]');
    if (!btn) return;
    // The button sits inside the card's <a> - swallow the navigation.
    event.preventDefault();
    event.stopPropagation();
    if (busy) return;
    busy = true;

    var variantId = parseInt(btn.dataset.quickAdd, 10);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: sectionIds(),
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (resp) {
        if (resp.status && resp.status !== 200) throw resp;
        var drawer = document.querySelector('cart-drawer');
        if (drawer && resp.sections && typeof drawer.renderContents === 'function') {
          // Dawn's own product form strips the HOST element's is-empty class
          // before calling renderContents (which only handles .drawer__inner).
          // Without this, adding to a previously empty cart renders the line
          // item but keeps the empty-cart layout - a blank drawer.
          drawer.classList.remove('is-empty');
          drawer.renderContents(resp);
        }
      })
      .catch(function () {})
      .then(function () {
        busy = false;
      });
  });
})();
